function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
export default defineComponent({
  name: 'BlockFullText',
  components: {
    YoutubePlayer: function YoutubePlayer() {
      return import('~/components/Molecules/YoutubePlayer.vue');
    }
  },
  props: {
    title: {
      type: String
    },
    content: {
      type: String
    },
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(_ref) {
    var displayOptions = _ref.displayOptions,
      content = _ref.content;
    var classes = useGetDisplayOptionsClasses(displayOptions);
    var modifiedHtml = ref('');
    var newHtml = ref([]);
    onMounted(function () {
      var _iterator = _createForOfIteratorHelper(parseHtml(content)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.getElementsByTagName('iframe').item(0) && /youtube/.test(item.outerHTML)) {
            item.classList.add('with-youtube-iframe');
          }
          newHtml.value.push(item);
          modifiedHtml.value += item.outerHTML;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    var parseHtml = function parseHtml(data) {
      var parser = new DOMParser();
      return parser.parseFromString(data, 'text/html').body.children;
    };
    var getContent = function getContent(node) {
      return node.outerHTML;
    };
    var getLink = function getLink(node) {
      if (node.classList.contains('with-youtube-iframe')) {
        return node.childNodes[0].src.replace('embed/', 'watch?v=');
      }
      return null;
    };
    return {
      classes: classes,
      modifiedHtml: modifiedHtml,
      newHtml: newHtml,
      getContent: getContent,
      getLink: getLink
    };
  }
});